import React from 'react';
import styles from './StepCounter.module.css';

export interface StepCounterProps {
    currentStep: number;
    totalSteps: number;
    onStepClick?: (step: number) => void;
}

export const StepCounter: React.FC<StepCounterProps> = ({ currentStep, totalSteps, onStepClick }) => {
    const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

    return (
        <div className={styles.wrapper}>
            {steps.map((step) => (
                <div key={step} className={styles.stepWrapper}>
                    <div
                        className={`${styles.circle} ${step <= currentStep ? styles.active : styles.inactive}`}
                        onClick={() => onStepClick?.(step)}
                        style={{ cursor: onStepClick ? 'pointer' : 'default' }}>
                        {step}
                    </div>
                </div>
            ))}
        </div>
    );
};
